
import { Component, OnInit } from '@angular/core';

import { ConfirmationService, MessageService } from 'primeng/api';



@Component({
  selector: 'app-doctemplates',
  templateUrl: './doctemplates.component.html',
  styleUrl: './doctemplates.component.scss',
  providers: [MessageService, ConfirmationService]
})
export class DoctemplatesComponent implements OnInit {

  constructor(
  ) { }

  ngOnInit(): void {
 

  }

  
}

